module.exports = __webpack_public_path__ + "img/1a940c4.png";